module.exports = __webpack_public_path__ + "img/default.76dc9f33.jpg";